// eslint-disable-next-line no-restricted-imports
import { H3 } from 'dripsy';

export default H3;
